import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import theme from '@theme';
import { StyledNavContainer } from './styled';

const HeaderNavContainer = ({ children, isSticky, isMenuItemsOpened }) => {
  const isMenuOpened = isMenuItemsOpened
    ? theme.colors.bg
    : theme.colors.bgSticky;
  const background = isSticky ? isMenuOpened : theme.colors.bg;

  return (
    <ThemeProvider theme={theme}>
      <StyledNavContainer background={background}>
        {children}
      </StyledNavContainer>
    </ThemeProvider>
  );
};

HeaderNavContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isSticky: PropTypes.bool.isRequired,
  isMenuItemsOpened: PropTypes.bool,
};

HeaderNavContainer.defaultProps = {
  isMenuItemsOpened: false,
};

export default HeaderNavContainer;
